<template>
<div>
    <HeaderTeam header="ตั้งค่า" :img_header="header_image" link_back="team" />
    <MenuTeamSettingList />
    <RoleList />
</div>
</template>

<script>
import HeaderImage from '@/assets/settings.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamSettingList from '@/components/menuadmin/team/teamsetting/MenuTeamSettingList.vue'
import RoleList from '@/components/menuadmin/team/teamsetting/RoleList.vue'
export default {
    name: 'role',
    components: {
        HeaderTeam,
        MenuTeamSettingList,
        RoleList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
